import usersNewWidgetTemplate from './usersNewWidget.html';
import './usersNewWidget.scss';

export default angular
  .module('main.dashboardPanel.usersNewWidget', [])

  .directive('usersNewWidget', () => {
    return {
      restrict: 'E',
      template: usersNewWidgetTemplate,
      scope: {},
      controller: ($scope,
                   $filter,
                   utils,
                   DashboardDataProvider) => {
        const $t = $filter('translate');

        $scope.noData = false;
        $scope.loading = true;

        init();

        function init() {

          DashboardDataProvider.getUsers(moment(DashboardDataProvider.now).subtract(1, 'w').valueOf(), moment(DashboardDataProvider.now).endOf('d').valueOf())
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let newUsers = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  x: execution.executionDateMs,
                  y: execution.data?.find(d => d.id === 2)?.value
                }));

              $scope.series = [
                {
                  data: newUsers,
                  label: $t('dash.panel.reports.newUsers.dashboardTitle')
                }
              ];


            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
